import React, { useRef, useState } from 'react';
import Application_process from '../../../assets/Application_process.mp4';
import { useTheme, useMediaQuery, IconButton } from "@mui/material";
import { VolumeUp, VolumeOff } from '@mui/icons-material';
import { motion } from "framer-motion";

export default function Fellow_Video() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

    const videoRef = useRef<HTMLVideoElement>(null);
    const [muted, setMuted] = useState(true);

    const toggleMute = () => {
        setMuted(!muted);
    };

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '30px',
                backgroundColor: '#f4f2f2',
                boxSizing: 'border-box',
            }}
        >
            {/* Video wrapper with relative positioning */}
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <motion.video
                    ref={videoRef}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                    src={Application_process}
                    autoPlay
                    loop
                    muted={muted}
                    playsInline
                    style={{
                        width: isMobile ? '90vw' : isTablet ? '80vw' : 'auto',
                        height: isMobile || isTablet ? 'auto' : '80vh',
                        objectFit: 'contain',
                        borderRadius: '24px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        display: 'block'
                    }}
                />

                {/* Mute/Unmute Button ON VIDEO */}
                <IconButton
                    onClick={toggleMute}
                    style={{
                        position: 'absolute',
                        bottom: '20px',
                        right: '20px',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        color: '#fff',
                        borderRadius: '50%',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                    }}
                >
                    {muted ? <VolumeOff /> : <VolumeUp />}
                </IconButton>
            </div>
        </div>
    );
}
